export const environment = {
  production: false,
  test: false,
  appSessionUniqueId: 'CFF75D1AD9996',
  userSessionUniqueId: 'FA25815678937',
  serverUrl: 'https://cavallinocaorletrapi.rrsolutionstest.it/api/v1/app',
  serverUrlAdmin: 'https://cavallinocaorletrapi.rrsolutionstest.it/api/v1/frontend',
  apiKey: '2mu2aFxYajsEUWHzmmri3pVv8tvVIs36'
};
